import { render, staticRenderFns } from "./SpinnerLoading.vue.html?vue&type=template&id=8ca0360a&scoped=true&"
import script from "./SpinnerLoading.component.js?vue&type=script&lang=vueJs&"
export * from "./SpinnerLoading.component.js?vue&type=script&lang=vueJs&"
import style0 from "./SpinnerLoading.scoped.scss?vue&type=style&index=0&id=8ca0360a&prod&lang=vueScss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca0360a",
  null
  
)

export default component.exports